import { Box, styled } from "@mui/material";

export const RecommendadionPumpContainer = styled<any>(Box)`
  padding: 16px;
  width: max-content;
  border: 1px solid #ffd200;
`;
